import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './authThunks';

const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logoutLocal: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    profileUpdated: (state, action) => {
      if (!state.user) return;
      const { first_name, last_name, email } = action.payload;

      if (email) state.user.email = email;
      if (first_name || last_name) {
        state.user.full_name = [first_name, last_name].filter(Boolean).join(' ');
      }

      if (state.user.admin) {
        if (first_name !== undefined) state.user.admin.first_name = first_name;
        if (last_name !== undefined) state.user.admin.last_name = last_name;
        if (email) state.user.admin.email = email;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      // Login Extra Reducers
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.token = action.payload.api_token;
        state.isAuthenticated = true;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const { logoutLocal, clearError, profileUpdated } = authSlice.actions;

export default authSlice.reducer;
